function isRunningInWebView() {
  // Most reliable: native app sets this before the page loads
  if (window.isNativeWebView === true) return true;

  // React Native WebView component sets this automatically
  if (window.ReactNativeWebView) return true;

  // iOS WKWebView: only present if the native side registered a message handler
  if (window.webkit && window.webkit.messageHandlers) return true;

  // Fallback: User-Agent sniffing (not 100% reliable)
  const ua = navigator.userAgent || '';
  const isAndroidWebView = /Android/.test(ua) && /\bwv\b/.test(ua);
  const isIOS = /iPhone|iPad|iPod/.test(ua) && !window.MSStream;
  const isIOSWebView = isIOS && !/Safari/.test(ua);

  return isAndroidWebView || isIOSWebView;
}

const closeWebView = (status) => {
  // iOS
  try {
    if (status === "success") {
      window.webkit.messageHandlers.onResultSuccess.postMessage("");
    } else {
      window.webkit.messageHandlers.onResultFailed.postMessage("");
    }
  } catch (error) {
    console.log(error);
  }

  // Android
  try {
    if (status === "success") {
      JSBridge.onResultSuccess();
    } else {
      JSBridge.onResultFailed();
    }
  } catch (error) {
    console.log(error);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  if (isRunningInWebView()) {
    document.querySelectorAll('.webview-close-button').forEach((el) => {
      el.style.display = 'block';
      el.addEventListener('click', () => closeWebView('success'));
    });
  }
   console.log('webview updated 2');
});